import { AutocompleteInput, ReferenceInput, required, SelectInput, TextInput } from "react-admin";
import SessionExamDates from "../Exams/components/SessionExamDates";
import SessionExamRooms from "../Exams/components/SessionExamRooms";
import SessionProfessors from "../Exams/components/SessionProfessors";
import { Grid } from "@mui/material";
import { administrationRequests } from "api/administrationApi";
import { useWatch } from "react-hook-form";
import { useEffect, useState } from "react";
import { ExamTypes } from "utils/constants";
import StudyGroupField from "server/components/Fields/StudyGroupField";
import ProfessorsModeWraper from "./ProfessorModeWrapper";
import { studentRequests } from "api/studentApi";
import dataProvider from "server/dataProvider";

const CyclicExamForm = ({ filters, mode = "create" }) => {
  const [cyclicSessionDateRange, setCyclicSessionDateRange] = useState(null);

  const { cyclicStreamId, structuralUnitId } = filters;

  const disciplineId = useWatch({ name: "disciplineId" });

  useEffect(() => {
    if (cyclicStreamId && disciplineId) {
      const fetchCyclicSessionDateRange = async ({ cyclicStreamId, disciplineId }) => {
        try {
          const { data } = await dataProvider.customRequest(
            studentRequests.getCyclicStreamSessionDates(cyclicStreamId, disciplineId),
            null,
            "GET",
          );
          setCyclicSessionDateRange(data);
        } catch (error) {
          console.error("Неуспешно зареждане на периода за изпитната сесия", error);
          setCyclicSessionDateRange(null);
        }
      };
      fetchCyclicSessionDateRange({ cyclicStreamId, disciplineId });
    }
  }, [cyclicStreamId, disciplineId]);

  return (
    <>
      <Grid
        container
        spacing={2}
      >
        <Grid
          item
          xs={12}
          md={4}
        >
          <ReferenceInput
            source="disciplineId"
            reference={studentRequests.getDisciplinesByCyclicStreamIdSelect(cyclicStreamId)}
            label="Дисциплина"
            filter={{
              CyclicStreamId: cyclicStreamId,
              StructuralUnitId: structuralUnitId,
            }}
          >
            <AutocompleteInput
              filterToQuery={q => (q?.length > 2 ? { disciplineName: q } : {})}
              label="Дисциплина"
              validate={required()}
            />
          </ReferenceInput>
        </Grid>

        {disciplineId && (
          <>
            <Grid
              item
              xs={12}
              md={4}
            >
              <ReferenceInput
                source="examTypeId"
                reference={administrationRequests.getExamTypesSelect()}
                label="Тип изпит"
              >
                <SelectInput
                  defaultValue={ExamTypes.InPerson}
                  label="Тип изпит"
                  optionText="nameBg"
                  emptyText={true}
                />
              </ReferenceInput>
            </Grid>
            <Grid
              item
              xs={12}
              md={4}
            >
              <TextInput
                source="note"
                label="Бележка"
              />
            </Grid>
          </>
        )}
      </Grid>

      <SessionExamRooms />
      <SessionExamDates sessionDateRange={cyclicSessionDateRange} />
      {disciplineId &&
        (mode === "edit" ? (
          <ProfessorsModeWraper disciplineId={disciplineId}></ProfessorsModeWraper>
        ) : (
          <SessionProfessors disciplineId={disciplineId} />
        ))}

      <Grid
        container
        spacing={2}
      >
        <Grid
          item
          xs={12}
          md={5}
        >
          <StudyGroupField
            isRequired={true}
            label=" Пример за въвеждане на Учебни групи: 1-5, 8, 11-13, 15. Оставете празно ако изпита се отнася за всички групи!"
          />
        </Grid>
      </Grid>
    </>
  );
};

export default CyclicExamForm;
